import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { featureuserTaskName, reducerUserTasks, UserViewEffects } from '@app/+userTasks/store';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
    imports: [
        StoreModule.forFeature(featureuserTaskName, reducerUserTasks),
        EffectsModule.forFeature([UserViewEffects])
    ]
})

export class UserViewStateModule {}
